import { render } from "./TransactionDetailModal.vue?vue&type=template&id=53599d8b&scoped=true"
import script from "./TransactionDetailModal.vue?vue&type=script&lang=js"
export * from "./TransactionDetailModal.vue?vue&type=script&lang=js"

import "./TransactionDetailModal.vue?vue&type=style&index=0&id=53599d8b&scoped=true&lang=css"

import exportComponent from "/private/var/www/html/goldenaces-club/vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53599d8b"]])

export default __exports__